// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"cede21c7753e1caa8672","655":"fb907bd59e1d8c683297"}[chunkId] + ".js";
};